import { useState, useEffect } from 'react';
import { locationAPI } from '../services/api';
import { LocationCoordinates } from '../types';

interface UseLocationResult {
  location: LocationCoordinates | null;
  loading: boolean;
  error: string | null;
  getCurrentLocation: (onChange?: (location: string, coordinates?: { lat: number; lng: number }) => void) => Promise<void>; // Changed return type to void
  updateUserLocation: (location: LocationCoordinates, locationName?: string) => Promise<void>;
  unsetLocation: () => Promise<void>;
}

export const useLocation = (): UseLocationResult => {
  const [location, setLocation] = useState<LocationCoordinates | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const getCurrentLocation = async (onChange?: (location: string, coordinates?: { lat: number; lng: number }) => void): Promise<void> => { // Fixed return type
    setLoading(true);
    setError(null);
    try {
      const coords = await locationAPI.getCurrentLocation();
      setLocation(coords); // Set the location in state instead of returning
      // console.log(onChange)

      if(onChange != undefined) {
        onChange(coords.name ? coords.name : "", {lat : coords.latitude, lng: coords.longitude})
      }
    } catch (err: any) {
      const errorMessage = err.message || 'Failed to get current location';
      setError(errorMessage);
      throw new Error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const unsetLocation = async (): Promise<void> => {
    setLocation(null);
  }

  const updateUserLocation = async (coords: LocationCoordinates, locationName?: string): Promise<void> => {
    try {
      await locationAPI.updateUserLocation({
        latitude: coords.latitude,
        longitude: coords.longitude,
        accuracy: coords.accuracy,
        location: locationName,
      });
      setLocation(coords);
    } catch (err: any) {
      const errorMessage = err.response?.data?.error || 'Failed to update location';
      setError(errorMessage);
      throw new Error(errorMessage);
    }
  };

  return {
    location,
    loading,
    error,
    getCurrentLocation,
    updateUserLocation,
    unsetLocation,
  };
};
